// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 9V3H20V9V21H15V9H9V21H4V9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 9V3H20V9M4 9V21M4 9H9M4 21H3M4 21H9M20 9V21M20 9H15M20 21H21M20 21H15M9 9V21M9 9H15M9 21H10M15 9V21M15 21H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam-2')
export default class Dam2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-2',
    }
  }
}
